import { useCallback } from 'react';
import { DATASET_KEY, STATIC_DATASETS_KEY, STATIC_DATASET_USAGE_KEY } from '@/utils/queryKeys.ts';
import { StaticDataset } from '@/types/datasets.ts';

const useInvalidateStaticDataset = (automationId: string) => {
  return useCallback(
    (staticDataset: StaticDataset): unknown[][] => {
      return [
        STATIC_DATASETS_KEY(automationId),
        STATIC_DATASET_USAGE_KEY(automationId),
        ['static-revisions', staticDataset.id],
        ['static-version-resources'],
        DATASET_KEY(staticDataset.dataset.id),
      ];
    },
    [automationId],
  );
};

export default useInvalidateStaticDataset;
